import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/gangs",
    name: "Gangs",
    component: () =>
      import(/*webpackChunkName:"Current-table" */ "../views/GangList")
  },
  {
    path: "/games",
    name: "GamesPlayed",
    component: () =>
      import(/*webpackChunkName:"Games-played" */ "../views/GamesPlayed")
  },
  {
    path: "/most-wanted",
    name: "MostWanted",
    component: () =>
      import(/*webpackChunkName:"Most-wanted" */ "../views/MostWanted")
  },
  {
    path: "/games/:id",
    name: "GamesDetails",
    props: true,
    component: () =>
      import(/*webpackChunkName:"Most-wanted" */ "../views/GamesDetails")
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
